import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const LockAlertIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M10 17c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m6-9c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h1V6c0-2.8 2.2-5 5-5s5 2.2 5 5v2h1m-6-5C8.3 3 7 4.3 7 6v2h6V6c0-1.7-1.3-3-3-3m12 10h-2V7h2v6m0 4h-2v-2h2v2z" />
  </SvgIcon>
);
LockAlertIcon.displayName = 'LockAlertIcon';
LockAlertIcon.muiName = 'SvgIcon';

export default LockAlertIcon;
